export default {
  namespaced: true,
  companies: {
    title: 'Empresas | Empresa',
    name: 'nombre',
    description: 'descripción',
    tenant: 'Tenant',
    companies: 'Empresas',
    select: 'Seleccionar'
  }
}
